import { render, staticRenderFns } from "./SearchData.vue?vue&type=template&id=64c1b650&scoped=true"
import script from "./SearchData.ts?vue&type=script&lang=ts&external"
export * from "./SearchData.ts?vue&type=script&lang=ts&external"
import style0 from "./SearchData.vue?vue&type=style&index=0&id=64c1b650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c1b650",
  null
  
)

export default component.exports